"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _valuehighlighter_styles = _interopRequireDefault(require("./valuehighlighter_styles"));

var _valuehighlighter_definition = _interopRequireDefault(require("./valuehighlighter_definition"));

var _definecomponent = require("../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : VALUE HIGHLIGHTER ~~~~~~~~~~ ========== */


var ValueHighlighter = (0, _reactJss.default)(_valuehighlighter_styles.default)(function (props) {
  // used to store all values to render (after updating specific values with spans for highlight purposes)
  var allValues = props.values;
  var highlightedValues = props.valuesToHighlight;
  var markedUpValues = []; // handle moving highlighted values to top of box (if prop passed)

  if (props.showHighlightedFirst) {
    var standardValsOnly = props.values.filter(function (value) {
      return !highlightedValues.includes(value);
    });
    allValues = highlightedValues.concat(standardValsOnly);
  } // loop each value and each highlighted val and add appropriate span to values we need to highlight, then push to array for formatting and rendering later


  allValues.forEach(function (val) {
    return markedUpValues.push(_react.default.createElement("span", {
      className: "value ".concat(highlightedValues.includes(val) ? 'highlighted' : 'standard'),
      key: val
    }, val));
  }); // format with comma for separation

  var valuesToRender = markedUpValues.reduce(function (acc, x) {
    return acc === null ? [x] : [acc, "".concat(props.separator || ''), x];
  }, null); // now render jsx

  return _react.default.createElement("div", {
    className: "valuehighlighter ".concat(props.classes.valuehighlighter)
  }, valuesToRender);
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(ValueHighlighter, _valuehighlighter_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = ValueHighlighter;
exports.default = _default;